import React, { PropTypes } from 'react'

import './SortOrderControl.scss'

const SortOrderControl = ({ value, onChange }) => {
  const handleChange = (e) => {
    onChange(e.target.value)
  }

  return (
    <div className='SortOrderControl'>
      <span>Ordernar por:</span>
      <select
        value={value}
        onChange={handleChange}
        >
        <option value={'by_finished_services'}>Recomendadas</option>
        <option value={'by_rating'}>Mayor calificación</option>
        <option value={'by_ascending_price_per_hour'}>Menor precio</option>
        <option value={'by_descending_price_per_hour'}>Mayor precio</option>
      </select>
    </div>
  )
}

SortOrderControl.displayName = 'SortOrderControl'
SortOrderControl.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

export default SortOrderControl



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/ChangeAliadaSearchBase/components/SortOrderControl/SortOrderControl.js